import { useSelector } from "react-redux";

import MyAccountRouter from "features/routers/MyAccountRouter";
import LogOut from "features/components/register/LogOut";
import { FooterNew, SideBarNew } from ".";
import { useEffect, useState } from "react";
import store from "features/store";
import { isAuthorized } from "shared/settings/auth";

export const MyAccountLayout = (props) => {
    const footer = useSelector(state => state.footer);
    const user = useSelector(state => state.user);

    return (
        isAuthorized() && user.id ? 
        <div className="d-flex flex-grow-1 w-100">
            {window.innerWidth > 991 && <SideBarNew {...props} />}

            <div className="d-flex flex-column w-100" style={{paddingLeft: window.innerWidth > 991 ? '295px' : ''}}>
                <MyAccountRouter {...props} />
                {
                    footer ?
                    <div className="bottom-layout">
                        <FooterNew {...props} />
                    </div> : null
                }
            </div>
        </div> :
        <LogOut />
    );
};